/* eslint-disable max-lines */
import Swal from "sweetalert2";
import { set_token, set_user_details,getCookie, csrf_headers } from "@/router";
import { client_domain } from "@/main.js";
import { authFinaleSharedMethods } from "@/views/auth_finale_helper";

const REGISTRATION_REDIRECT_RULES = [
    {
        matches: (context) => context.is_organization_registration(),
        get_url: () => '/home_filter/',
    },
    {
        matches: (context) => context.has_dynamic_forms_feature(),
        get_url: (context, user_details) => context.get_profile_name_update_url(user_details),
    },
    {
        matches: (context) => context.is_bosa_domain(),
        get_url: (context, user_details) => context.get_bosa_registration_redirect_url(user_details),
    },
    {
        matches: (context) => context.cbo_domain,
        get_url: () => '/view_events',
    },
    {
        matches: (context) => context.client_features?.marketplace,
        get_url: () => '/marketplace',
    },
];

export default {
    inject: ['client_features'],

    data() {
        return ({
            login_url: '',
            first_name: '',
            last_name: '',
            email: '',
            phone_number: '',
            account_type: 'individual',
            organization_name: '',
            type_of_organization: [],
            selected_type_of_organization: '',
            custom_type_of_organization: '',
            user_type: 'parent',
            password: '',
            confirm_password: '',
            passwordVisible: false,
            confirmPasswordVisible: false,
            errors: {},
            passed: false,
            cbo_domain: false,
            bosa_domain: false,
            vettedsa_domain: false,
            csrfToken: '',
            school_domain: false
        });
    },
    mounted() {
        if (client_domain.includes('cbo')) {
            this.cbo_domain = true;
        }
        if (this.is_bosa_domain()) {
            this.bosa_domain = true;
        }
        if (client_domain.includes('vettedsa')) {
            this.vettedsa_domain = true;
        }
        this.csrfToken = getCookie('csrftoken');
        if (client_domain.includes('chiefluthuli')) {
            this.school_domain = true;
        }
        this.fetch_type_of_organization();
    },
    methods: {
        ...authFinaleSharedMethods,
        apply_registration_field_error(response_status) {
            if (response_status?.status !== 'error') {
                return false;
            }

            const response_message = String(response_status.message || '').toLowerCase();
            if (response_message.includes('email')) {
                this.errors.email = response_message;
                return true;
            }

            if (response_message.includes('phone number')) {
                this.errors.phone_number = response_message;
                return true;
            }

            return false;
        },
        get_registration_general_error(httpStatus, textStatus) {
            if (httpStatus === 403) {
                return 'Forbidden (403). CSRF token missing/invalid or cookies not included.';
            }

            if (httpStatus) {
                return `Request failed (HTTP ${httpStatus}).`;
            }

            return `Request failed (${textStatus || 'network error'}).`;
        },
        is_organization_registration() {
            return this.account_type === 'organization' || this.is_show_organisation_enabled();
        },

        get_signup_endpoint() {
            return this.is_organization_registration() ? 'register_organization' : 'register_user';
        },

        async register_user() {
            this.validateForm();

            if (!this.passed) {
                return;
            }

            this.clear_profile_modal_session();
            await this.ensure_csrf_cookie();

            Swal.fire({
                title: 'Saving...',
                text: 'Please wait while we save the user data.',
                allowOutsideClick: false,
                showConfirmButton: false,
                onOpen: () => {
                    Swal.showLoading();
                }
            });

            const baseUrl = `${window.location.origin}`;

            $.ajax({
                type: "POST",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/${this.get_signup_endpoint()}/`,
                xhrFields: { withCredentials: true },
                headers: {
                    'Content-Type': 'application/json',
                    ...csrf_headers(this.csrfToken)
                },
                data: JSON.stringify({
                    role: "user",
                    email: this.email,
                    last_name: this.last_name,
                    first_name: this.first_name,
                    phone_number: this.phone_number,
                    account_type: this.is_organization_registration() ? 'organization' : this.account_type,
                    organization_name: this.is_organization_registration() ? this.organization_name : '',
                    type_of_organization_id: this.is_organization_registration() && !this.is_custom_organization_type() ? this.selected_type_of_organization : '',
                    type_of_organization: this.is_organization_registration() && this.is_custom_organization_type() ? this.custom_type_of_organization : '',
                    custom_type_of_organization: this.is_organization_registration() && this.is_custom_organization_type() ? this.custom_type_of_organization : '',
                    user_type: this.user_type,
                    password: this.password,
                    base_url: baseUrl
                }),
                success: (response) => {
                    if (response.status === "success") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Registration Successful',
                            showConfirmButton: false,
                            timer: 2000,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
                            const response_data = response.data;

                            if (!response_data?.token) {
                                window.location = '/sign_in_finale';
                                return;
                            }

                            const user_details = this.get_user_details_payload(response_data);
                            set_token(response_data.token);
                            set_user_details(user_details);
                            this.set_active_organization_profile(response_data);

                            const redirect_url = this.get_registration_redirect_url(user_details);
                            window.location = redirect_url;
                        });
                    }
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    this.handle_registration_error(jqXHR, textStatus, errorThrown);
                }
            });
        },
        handle_registration_error(jqXHR, textStatus, errorThrown) {
            Swal.close();

            const response_status = jqXHR?.responseJSON || null;
            if (this.apply_registration_field_error(response_status)) return;

            const httpStatus = jqXHR?.status;
            this.errors.general = this.get_registration_general_error(httpStatus, textStatus);

            console.warn('register_user failed', {
                httpStatus,
                textStatus,
                errorThrown,
                response_status
            });
        },
        get_registration_redirect_url(user_details) {
            const redirect_rule = REGISTRATION_REDIRECT_RULES.find((rule) =>
                rule.matches(this, user_details)
            );

            return redirect_rule
                ? redirect_rule.get_url(this, user_details)
                : this.get_default_registration_redirect_url();
        },
        get_bosa_registration_redirect_url(user_details) {
            return this.has_missing_required_profile_details(user_details)
                ? this.get_profile_name_update_url(user_details)
                : '/home';
        },
        get_default_registration_redirect_url() {
            return sessionStorage.getItem('next') || '/home';
        },
        get_profile_name_update_url(user_details) {
            this.set_profile_modal_session(user_details);
            return '/profile';
        },
        validateForm() {
            this.errors = {};
            const validation_results = [
                this.validate_organization_details(),
                this.validate_required_name_fields(),
                this.validate_email_field(),
                this.validate_password_field(),
                this.validate_confirm_password_field(),
            ];

            this.passed = validation_results.every(Boolean);
        },
        validate_organization_details() {
            if (!this.is_organization_registration()) return true;

            return [
                this.set_field_error(!this.organization_name, 'organization_name', 'Organisation name is required'),
                this.set_field_error(!this.selected_type_of_organization, 'type_of_organization_id', 'Type of organisation is required'),
                this.set_field_error(this.has_missing_custom_organization_type(), 'type_of_organization_id', 'Enter your type of organisation'),
            ].every(Boolean);
        },
        validate_required_name_fields() {
            return [
                this.set_field_error(this.has_short_name(this.first_name), 'first_name', 'First name is required'),
                this.set_field_error(this.has_short_name(this.last_name), 'last_name', 'Last name is required'),
            ].every(Boolean);
        },
        validate_email_field() {
            if (!this.email) return this.set_validation_error('email', 'Email is required');
            if (!this.isValidEmail(this.email)) return this.set_validation_error('email', 'Please enter a valid email');

            this.errors.email = '';
            return true;
        },
        validate_password_field() {
            if (!this.password) return this.set_validation_error('password', 'Password is required');
            if (!this.isValidPassword(this.password)) {
                return this.set_validation_error('password', 'Password must be at least 8 characters, contain at least one uppercase letter, one lowercase letter, one digit, and one special character');
            }

            this.errors.password = '';
            return true;
        },
        validate_confirm_password_field() {
            if (!this.confirm_password) return this.set_validation_error('confirm_password', 'Confirm password is required');
            if (this.password !== this.confirm_password) return this.set_validation_error('confirm_password', 'Passwords do not match');

            this.errors.confirm_password = '';
            return true;
        },
        set_field_error(has_error, field, message) {
            if (has_error) return this.set_validation_error(field, message);
            if (!Reflect.get(this.errors, field)) Reflect.set(this.errors, field, '');

            return true;
        },
        set_validation_error(field, message) {
            Reflect.set(this.errors, field, message);
            return false;
        },
        has_short_name(name) {
            return !name || name.length <= 2;
        },
        has_missing_custom_organization_type() {
            return this.is_custom_organization_type() && !this.custom_type_of_organization.trim();
        },
        fetch_type_of_organization() {
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_type_of_organization/`,
                type: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                success: (response) => {
                    if (response.status === 'success') {
                        this.type_of_organization = response.data.type_of_organization_data;
                    }
                },
            });
        },
        is_custom_organization_type() {
            return this.selected_type_of_organization === 'other';
        },
        isValidEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).toLowerCase());
        },
        isValidPhoneNumber(phone_number) {
            const re = /^[\d\-+()]+$/;
            return re.test(phone_number);
        },

        togglePasswordVisibility(field) {
            if (field === 'password') {
                this.passwordVisible = !this.passwordVisible;
            } else if (field === 'confirm') {
                this.confirmPasswordVisible = !this.confirmPasswordVisible;
            }
        },
        isValidPassword(password) {
            const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
            return re.test(password);
        },


    }
};



